module.exports = __webpack_public_path__ + "img/statistiche_smartbook.a1a44f74.png";